import { render, staticRenderFns } from "./NewChangePasswordForm.vue?vue&type=template&id=a3d2ebe8&scoped=true"
import script from "./NewChangePasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./NewChangePasswordForm.ts?vue&type=script&lang=ts&external"
import style0 from "./NewChangePasswordForm.vue?vue&type=style&index=0&id=a3d2ebe8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d2ebe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d2ebe8')) {
      api.createRecord('a3d2ebe8', component.options)
    } else {
      api.reload('a3d2ebe8', component.options)
    }
    module.hot.accept("./NewChangePasswordForm.vue?vue&type=template&id=a3d2ebe8&scoped=true", function () {
      api.rerender('a3d2ebe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/NewChangePasswordForm/NewChangePasswordForm.vue"
export default component.exports